import { HttpClient } from '@angular/common/http';
import { ThemingService } from '@fino-ui/theming';
import type { TranslationObject } from '@fino-ui/translation';
import { TranslateService } from '@fino-ui/translation';
import { KeycloakService } from 'keycloak-angular';
import { SessionStorageService } from 'ngx-webstorage';
import { AppService } from 'src/app/app.service';
import { OVERVIEW_MODEL } from 'src/app/modules/overview/overview.component';
import { Api } from '../api/Api';
import { initializeKeycloak } from '../auth/keycloak';

export const THEMES = {
  VR: 'VR',
  SPARKASSE: 'SPARKASSE',
  EVANGELISCHE_BANK: 'EVANGELISCHE_BANK',
};

const TENANT_PRIMARY_INVERT = {
  [THEMES.SPARKASSE]: '#FFFFFF',
};

export function loadConfig(
  http: HttpClient,
  keycloak: KeycloakService,
  appService: AppService,
  themingService: ThemingService,
  translateService: TranslateService,
  sessionService: SessionStorageService,
) {
  return () =>
    new Promise((resolve, reject) => {
      return http.get(Api.Config).subscribe((resp: any) => {
        initializeKeycloak(keycloak, resp.keycloakHost)
          .then(() => {
            http.get(Api.ProductsAvailable).subscribe((resp: any) => {
              const tenant = appService.tenant as string;
              const choosenTheme = resp.theme;

              appService.availableProducts.set({
                hasKwh: resp.hasKwh,
                canConfigureKwh: resp.canConfigureKwh,
                canConfigureKws: resp.canConfigureKws,
                hasKws: resp.hasKws,
                hasDws: resp.hasDws,
              });

              // set logo from session storage if present
              const logoUrl = sessionService.retrieve(OVERVIEW_MODEL)
                ? sessionService.retrieve(OVERVIEW_MODEL).logoUrl
                : resp.logoUrl;

              appService.logoUrl.set(logoUrl);

              themingService.renderTheme({
                name: choosenTheme,
                primaryColor: resp.primaryColor || '#4D4D4D',
                primaryInvertColor: TENANT_PRIMARY_INVERT[choosenTheme],
                tenant,
                tenantDisplayName: 'Kontowechsel Control Panel',
                logo: appService.logoUrl(),
              });

              http.get(`/assets/i18n/${choosenTheme}/de.json`).subscribe({
                next: (resp: TranslationObject) => {
                  translateService.setTranslation('de', resp, true);
                },
                error: (resp) => {},
              });

              resolve(true);
            });
          })
          .catch((err) => reject(err));
      });
    });
}
